import { Observable } from 'rxjs';

/**
 * Abstract DI token for fetching a server-defined action form (FormDataDescribed) for a
 * dashboard panel.  Provided by the host application so that the generic table component
 * can make the request through the correct HTTP service (CsHttpClient + BASE_PATH) without
 * coupling @cs/components/dashboard to any application-specific API service.
 *
 * Provide alongside DashboardConfigService in any module that uses table-nxt panels with
 * RegisteredAction menu items:
 *   { provide: DashboardActionFormProvider, useExisting: DashboardConfigService }
 */
export abstract class DashboardActionFormProvider {
	abstract getActionFormForPanel(
		gridName: string,
		dashboardName: string,
		panelName: string,
		contextData: { [key: string]: any }
	): Observable<any>;
}
